/**
 * @Copyright (c) 2021 DigiNet
 * @author NHATLONG
 * @create 11/11/2021
 * @Example
 */


import Api from '../../../services/api';
import { cancel, take, takeLatest, put, takeEvery } from "redux-saga/effects";
import { types } from "./W05F0012_actions";
import { delay } from "redux-saga";

export default function W05F0012Sagas() {
    return [
        watchGetList(),
        watchGetCboEmployees(),
        watchGetCboCurrency(),
        watchGetBaseCurrency(),
        watchGetDecimalQuantity(),
        watchGetCboPorts(),
        watchGetCboBanks(),
        watchGetCboMarking(),
        watchGetCboPackingType(),
        watchGetCboPaymentTerm(),
        watchSubContractNo(),
        watchOnSave(),
        watchOnEdit()
    ];
}

export function* getList(data) {
    try {
        yield delay(300);
        const response = yield Api.put('/w05f0012/get-list', data.params);
        if (response && response.data) {
            data.cb && data.cb(null, response.data);
        }
        else {
            data.cb && data.cb(response, null);
        }
    } catch (e) {
        console.log('getList error')
    }
}
export function* watchGetList() {
    while (true) {
        const watcher = yield takeEvery(types.W05F0012_GET_LIST, getList);
        yield take(['LOGOUT', 'NETWORK']);
        yield cancel(watcher);
    }

}

export function* getCboEmployees(data) {
    try {
        yield delay(300);
        const response = yield Api.put('/w05f0000/get-combo-employee', data.params);
        if (response && response.data) {
            data.cb && data.cb(null, response.data);
        }
        else {
            data.cb && data.cb(response, null);
        }
    } catch (e) {
        console.log('getCboEmployees error')
    }
}
export function* watchGetCboEmployees() {
    while (true) {
        const watcher = yield takeLatest(types.W05F0012_GET_CBO_EMPLOYEE, getCboEmployees);
        yield take(['LOGOUT', 'NETWORK']);
        yield cancel(watcher);
    }

}


export function* getCboCurrency(data) {
    try {
        yield delay(300);
        const response = yield Api.get('/w05f0000/get-combo-currency');
        if (response && response.data) {
            data.cb && data.cb(null, response.data);
        }
        else {
            data.cb && data.cb(response, null);
        }
    } catch (e) {
        console.log('getCboCurrency error')
    }
}
export function* watchGetCboCurrency() {
    while (true) {
        const watcher = yield takeLatest(types.W05F0012_GET_CBO_CURRENCY, getCboCurrency);
        yield take(['LOGOUT', 'NETWORK']);
        yield cancel(watcher);
    }

}

export function* getBaseCurrency(data) {
    try {
        yield delay(300);
        const response = yield Api.get('/w05f0000/get-base-currency');
        if (response && response.data) {
            data.cb && data.cb(null, response.data);
        }
        else {
            data.cb && data.cb(response, null);
        }
    } catch (e) {
        console.log('getBaseCurrency error')
    }
}
export function* watchGetBaseCurrency() {
    while (true) {
        const watcher = yield takeLatest(types.W05F0012_GET_BASE_CURRENCY, getBaseCurrency);
        yield take(['LOGOUT', 'NETWORK']);
        yield cancel(watcher);
    }

}

export function* getDecimalQuantity(data) {
    try {
        yield delay(300);
        const response = yield Api.put('/w05f0000/get-decimal-quantity', data.params);
        if (response && response.data) {
            yield put({ type: types.W05F0012_GET_DECIMAL_QUANTITY_SUCCESS, data: response.data });
            data.cb && data.cb(null, response.data)
        }
        else {
            data.cb && data.cb(response, null)
        }
    }
    catch (e) {
        console.log('get decimal quantity error');
    }
}
export function* watchGetDecimalQuantity() {
    while (true) {
        const watcher = yield takeLatest(types.W05F0012_GET_DECIMAL_QUANTITY, getDecimalQuantity);
        yield take(['LOGOUT', 'NETWORK']);
        yield cancel(watcher);
    }
}

export function* getCboPorts(data) {
    try {
        yield delay(300);
        const response = yield Api.get('/w05f0000/get-combo-port');
        if (response && response.data) {
            data.cb && data.cb(null, response.data)
        }
        else {
            data.cb && data.cb(response, null)
        }
    }
    catch (e) {
        console.log('get cbo ports error');
    }

}
export function* watchGetCboPorts() {
    while (true) {
        const watcher = yield takeLatest(types.W05F0012_GET_CBO_PORTS, getCboPorts);
        yield take(['LOGOUT', 'NETWORK']);
        yield cancel(watcher);
    }
}

export function* getCboBanks(data) {
    try {
        yield delay(300);
        const response = yield Api.get('/w05f0000/get-combo-bank');
        if (response && response.data) {
            data.cb && data.cb(null, response.data)
        }
        else {
            data.cb && data.cb(response, null)
        }
    }
    catch (e) {
        console.log('get cbo banks error');
    }

}
export function* watchGetCboBanks() {
    while (true) {
        const watcher = yield takeLatest(types.W05F0012_GET_CBO_BANKS, getCboBanks);
        yield take(['LOGOUT', 'NETWORK']);
        yield cancel(watcher);
    }
}

export function* getCboMarking(data) {
    try {
        yield delay(300);
        const response = yield Api.put('/w05f0000/get-combo-marking', data.params);
        if (response && response.data) {
            data.cb && data.cb(null, response.data)
        }
        else {
            data.cb && data.cb(response, null)
        }
    }
    catch (e) {
        console.log('get cbo marking error');
    }
}
export function* watchGetCboMarking() {
    while (true) {
        const watcher = yield takeLatest(types.W05F0012_GET_CBO_MARKING, getCboMarking);
        yield take(['LOGOUT', 'NETWORK']);
        yield cancel(watcher);
    }
}

export function* getCboPackingType(data) {
    try {
        yield delay(300);
        const response = yield Api.put('/w05f0000/get-combo-packing-type', data.params);
        if (response && response.data) {
            data.cb && data.cb(null, response.data)
        }
        else {
            data.cb && data.cb(response, null)
        }
    }
    catch (e) {
        console.log('get cbo packing type error');
    }
}
export function* watchGetCboPackingType() {
    while (true) {
        const watcher = yield takeLatest(types.W05F0012_GET_CBO_PACKING_TYPE, getCboPackingType);
        yield take(['LOGOUT', 'NETWORK']);
        yield cancel(watcher);
    }
}

export function* getCboPaymentTerm(data) {
    try {
        yield delay(300);
        const response = yield Api.get('/w05f0000/get-combo-payment-term');
        if (response && response.data) {
            data.cb && data.cb(null, response.data)
        }
        else {
            data.cb && data.cb(response, null)
        }
    }
    catch (e) {
        console.log('get cbo payment term error');
    }
}
export function* watchGetCboPaymentTerm() {
    while (true) {
        const watcher = yield takeLatest(types.W05F0012_GET_CBO_PAYMENT_TERM, getCboPaymentTerm);
        yield take(['LOGOUT', 'NETWORK']);
        yield cancel(watcher);
    }
}

export function* subContractNo(data) {
    try {
        yield delay(300);
        const response = yield Api.put('/w05f0009/last-key', data.params);
        if (response && response.data) {
            data.cb && data.cb(null, response.data)
        }
        else {
            data.cb && data.cb(response, null)
        }
    }
    catch (e) {
        console.log('subContractNo error');
    }
}
export function* watchSubContractNo() {
    while (true) {
        const watcher = yield takeLatest(types.W05F0012_SUBCONTRACTNO, subContractNo);
        yield take(['LOGOUT', 'NETWORK']);
        yield cancel(watcher);
    }
}

export function* onSave(data) {
    try {
        yield delay(300);
        const response = yield Api.put('/w05f0012/save', data.params);
        if (response && response.data) {
            data.cb && data.cb(null, response.data)
        }
        else {
            data.cb && data.cb(response, null)
        }
    }
    catch (e) {
        console.log('onSave error');
    }
}
export function* watchOnSave() {
    while (true) {
        const watcher = yield takeLatest(types.W05F0012_SAVE, onSave);
        yield take(['LOGOUT', 'NETWORK']);
        yield cancel(watcher);
    }
}

export function* onEdit(data) {
    try {
        yield delay(300);
        const response = yield Api.put('/w05f0012/edit', data.params);
        if (response && response.data) {
            data.cb && data.cb(null, response.data)
        }
        else {
            data.cb && data.cb(response, null)
        }
    }
    catch (e) {
        console.log('onEdit error');
    }
}
export function* watchOnEdit() {
    while (true) {
        const watcher = yield takeLatest(types.W05F0012_EDIT, onEdit);
        yield take(['LOGOUT', 'NETWORK']);
        yield cancel(watcher);
    }
}
